const chart = {
  bindings: {
    config: '<',
    series: '<',
  },
  templateUrl: '/modules/common/chart/chart-module.html',
  controller: 'ChartController',
};

angular
.module('chart.module', [])
.component('chart', chart);